export const isWebLink = (link = '/') =>
  ['http://', 'https://', 'www.'].some(prefix => link.includes(prefix));
